/* S1 Media Gallery — swipe is native scroll-snap; settling on a slide
   updates the dots (timeout debounce — rAF can starve in background
   documents); dots and wrap-around prev/next drive the track with a smooth
   scroll (echo-locked so intermediate slides don't flicker the state). */

class S1MediaGallery extends HTMLElement {
  connectedCallback() {
    if (this._wired) return;
    this.track = this.querySelector('[data-mg-track]');
    this.slides = Array.from(this.querySelectorAll('[data-mg-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-mg-dot]'));
    if (!this.track || this.slides.length < 2) return;
    this._wired = true;
    this._index = 0;
    this._lockUntil = 0;

    let settle = 0;
    this.track.addEventListener('scroll', () => {
      clearTimeout(settle);
      settle = setTimeout(() => {
        if (Date.now() < this._lockUntil) return;
        const idx = this.nearestSlide();
        if (idx !== this._index) this.setActive(idx);
      }, 80);
    }, { passive: true });

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.go(Number(dot.dataset.mgDot)));
    });
    this.querySelector('[data-mg-prev]')?.addEventListener('click', () => this.go((this._index - 1 + this.slides.length) % this.slides.length));
    this.querySelector('[data-mg-next]')?.addEventListener('click', () => this.go((this._index + 1) % this.slides.length));
  }

  nearestSlide() {
    const centre = this.track.scrollLeft + this.track.clientWidth / 2;
    let best = 0, bestDist = Infinity;
    this.slides.forEach((slide, i) => {
      const dist = Math.abs(slide.offsetLeft + slide.clientWidth / 2 - centre);
      if (dist < bestDist) { bestDist = dist; best = i; }
    });
    return best;
  }

  go(index) {
    this.setActive(index);
    const slide = this.slides[index];
    if (!slide) return;
    this._lockUntil = Date.now() + 700;
    this.track.scrollTo({
      left: slide.offsetLeft + slide.clientWidth / 2 - this.track.clientWidth / 2,
      behavior: 'smooth',
    });
  }

  setActive(index) {
    this._index = index;
    this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
  }
}

if (!customElements.get('s1-media-gallery')) {
  customElements.define('s1-media-gallery', S1MediaGallery);
}
